var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"checkout"}},[(_vm.loading)?[_c('bounce-loader')]:[_c('thank-you-page'),_vm._v(" "),_c('HelpProblems',{attrs:{"order":_vm.paidOrder}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }